export function SET_FILTERS({ commit }, [progress, search, selected_areas, selected_groups, selected_tags]) {
    commit('SAVE_FILTERS', [progress, search, selected_areas, selected_groups, selected_tags])
}

export function SET_WEBINAR_STATUS({ commit }, [webinar_status]) {
    commit('SAVE_WEBINAR_STATUS', [webinar_status])
}

export function SET_WEBINAR_IS_ONLINE({ commit }, [webinar_is_online]) {
    commit('SAVE_WEBINAR_IS_ONLINE', [webinar_is_online])
}
export function SET_LOUNGE_TEMPLATE(context, [webcast_lounge_template]) {
    context.commit('SAVE_LOUNGE_TEMPLATE', [webcast_lounge_template])
}

export function SET_PROGRESS({ commit }, progress) {
    commit('SAVE_PROGRESS', progress)
}

export function SET_FILTER_AREA({ commit }, selected_areas) {
    commit('SAVE_FILTER_AREA', selected_areas)
}

export function SET_LOADING({ commit }, loading) {
    commit('SAVE_LOADING', loading)
}